export default __webpack_public_path__ + "img/rich_2-0133c3c4.png";